export * from './components/logs/logs.component';
export * from './logs.module';



// WEBPACK FOOTER //
// ./src/app/logs/index.ts